export enum DateTimeFormat {
  DateFull = 'yyyy-MM-dd', // 2022-11-07
  Time = 'HH:mm', // 13:21
  TimeFull = 'hh:mm aaa', // 01:21 pm
  WeekdayFull = 'EEEE', // Monday
}
